import React, { useState } from 'react'
import innerStyles from "./InnerStyles.module.css"
import axios from 'axios'
import "animate.css"

import Aboutimg from './assets/bookappointmentlogo.png'
const BookAppointment = () => {
  const[trname,setTrname]=useState("");
  const[dname,setDname]=useState("")
  const[pname,setPname]=useState("")
  const[pphone,setPphone]=useState("")
  const[pemail,setPemail]=useState("")
  const[plocation,setPlocation]=useState("")
  const[pmessage,setPmessage]=useState("")
    const[loading,setLoading]=useState(false)
  
  
   const addServiceData=(e)=>{
     if(loading) return;
    setLoading(true);
    e.preventDefault();
    axios.post(`https://backendsurgylife-1.onrender.com/bookappointment`,{
      trname,dname,pname,pphone,pemail,plocation,pmessage,
    })
    .then((res)=>{
      alert("✅  Appointment Booked Successfully")
      setTrname("")
      setDname("");
      setPname("");
      setPphone("");
      setPemail("");
      setPlocation("");
      setPmessage("");
    })
    .catch((err)=>{
      alert("Error book appointment")
    })
      .finally(()=>{
      setLoading(false);
    })
  }
  return (
    
  <main>
       
               <section className={innerStyles.breadgum}>
                   <div className='container'>
                       <div className='row'>
                           <div className='col-md-12'>
                               <h1>Book Appointment</h1>
                           </div>
                       </div>
                   </div>
               </section>

                    <section className='py-5'>
                    <div className='container'>
                      <div className='row'>
                           <div className='col-md-5 mb-5'>
<img 
  src={Aboutimg} 
  alt="logo" 
  className={`img-fluid rounded-3 animate__animated animate__fadeInLeft ${innerStyles.about}`}
/>
                        </div>

                        <div className='col-md-7 mx-auto mt-2 p-3'>
                        <form className={innerStyles.bx_shadow} onSubmit={addServiceData}>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='trname'
                                 className='form-control'
                                 placeholder='Treatment Name'
                                 value={trname}
                                 onChange={(e)=>setTrname(e.target.value)}
                                         required //Mandatory

                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='dname'
                                 className='form-control'
                                 placeholder='Doctor Name'
                                 value={dname}
                                 onChange={(e)=>setDname(e.target.value)}
                                                                      required //Mandatory

                                 />
                              </div>
                            </div>

                          </div>

                              <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='pname'
                                 className='form-control'
                                 placeholder='Patient Name'
                                 value={pname}
                                 onChange={(e)=>setPname(e.target.value)}
                                                                      required //Mandatory

                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='pphone'
                                 className='form-control'
                                 placeholder='Patient Phone'
                                 value={pphone}
                                 onChange={(e)=>setPphone(e.target.value)}
                                                                      required //Mandatory

                                 />
                              </div>
                            </div>

                          </div>

                              <div className='row'>
                            <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='pemail'
                                 className='form-control'
                                 placeholder='Patient Email'
                                 value={pemail}
                                 onChange={(e)=>setPemail(e.target.value)}
                                                                      required //Mandatory

                                 />
                              </div>
                            </div>

                             <div className='col-md-6'>
                              <div className='mb-4'>
                                <input type='text' 
                                name='plocation'
                                 className='form-control'
                                 placeholder='Patient Location'
                                 value={plocation}
                                 onChange={(e)=>setPlocation(e.target.value)}
                                                                      required //Mandatory

                                 />
                              </div>
                            </div>
                          </div>

                              <div className='row'>
                            <div className='col-md-12'>
                              <div className='mb-4'>
                                <textarea 
                                name='pmessage'
                                 className='form-control'
                                 placeholder='Patient Message'
                                 value={pmessage}
                                 onChange={(e)=>setPmessage(e.target.value)}
                                 rows='5'
                                                                      required //Mandatory

                                 > </textarea>
                              </div>
                                 {/* <input type='submit'
                                 value='Book Appointment'
                                 className='btn btn-success'
                                 /> */}




           
              <div className='mb-3'>
                                                <button type='submit' className={`btn btn-success
                                                   d-flex 
                                                   align-items-center
                                                   justify-content-center
                                                   gap-2 ${innerStyles.btn}
                                                   `}
                                                   disabled={loading}
                                                   >
                                                    {
                                                      loading && (
                                                        <div className='spinner-border spinner-border-sm text-light ' role='status'>
                                                          <span className='visually-hiiden'>Loading ...</span>
                                                        </div>
                                                      )}
            
                                                        {loading ? "Sending..": "Send Message"}
                                                </button>
                                              </div>                     

                            </div>
                          </div>
                        </form>
                        </div>


                     
                      </div>
                    </div>
                   </section>



                   </main>

       
    )
}

export default BookAppointment
